import React, {useRef} from "react";
import {AutoComplete} from "primereact/autocomplete";
import {Calendar} from "primereact/calendar";

const StoreHeaderSection = ({
	selectedViewOrder,
	setSelectedViewOrder,
	setSelectedOrder,
	filteredOrders,
	searchOrders,
	shipmentDate,
	setShipmentDate,
	isEditMode,
}) => {
	const dateInputRef = useRef(null);

	const handleOrderChange = (value) => {
		if (isEditMode) return;
		setSelectedViewOrder(value);
	};

	const handleOrderSelect = (e) => {
		if (isEditMode) return;
		setSelectedViewOrder(e.value);
		setSelectedOrder(e.value);
	};

	const handleOrderClear = () => {
		if (isEditMode) return;
		setSelectedViewOrder("");
		setSelectedOrder(null);
	};

	return (
		<div className="flex items-center justify-between w-full gap-4">
			<div className="flex items-center gap-4">
				<div>
					<p className="pb-2 text-xl">Seriya nomer</p>
					<AutoComplete
						suggestions={filteredOrders}
						completeMethod={searchOrders}
						onChange={(e) => handleOrderChange(e.value)}
						onSelect={handleOrderSelect}
						onClear={handleOrderClear}
						value={selectedViewOrder}
						placeholder="Seriya номер танлаш"
						className="w-[12em] border h-[46px] pt-[2px] rounded-md"
						inputClassName="w-full h-full pl-2"
						aria-label="Seriya nomer tanlash"
						disabled={isEditMode}
					/>
				</div>
			</div>
			<div>
				<p className="pb-2 text-xl">Сана</p>
				<div className="relative min-w-[12em] border border-gray-300 rounded-md shadow-sm bg-white hover:border-blue-500 focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500 transition-all duration-200">
					<Calendar
						value={shipmentDate}
						onChange={(e) => setShipmentDate(e.value)}
						className="!w-full calendar-custom"
						dateFormat="dd.mm.yy"
						inputRef={dateInputRef}
						inputClassName="!border-none !shadow-none !outline-none px-3 py-3 w-full text-sm bg-transparent"
						onSelect={() => {
							setTimeout(() => dateInputRef.current?.blur(), 125);
						}}
						showIcon
						iconPos="right"
					/>
				</div>
			</div>
		</div>
	);
};

export default StoreHeaderSection;
